export default __webpack_public_path__ + "static/korea-8204f735e390b49debf8e4ff0e68fc3a.svg";